module.exports = __webpack_public_path__ + "static/media/HIPAA_Badge.0af38183.png";